import React, { useEffect, useRef } from "react";
import { useFixBody } from "@state/hooks/shared";
import { observer } from "mobx-react";

import {
	BetBuilderPickEventPopupBody,
	BetBuilderPicksPopupFooter,
	BetBuilderPicksPopupHeader,
} from "./components/BetBuilderPopup";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";

export default observer(function BetBuilderPicksEventPopup() {
	const store = useOfferContext<OfferStore.EventViewStore>();

	const popupElement = useRef<null | HTMLDivElement>(null);

	useFixBody(
		true,
		store?.betBoosterEventPicks?.betBuilderPicksStore?.isPopupDisplayed
	);

	useEffect(() => {
		popupElement.current?.scrollTo({ top: 0 });
	}, [store?.betBoosterEventPicks?.betBuilderPicksStore?.selectedBetSlip]);

	if (!store?.betBoosterEventPicks?.betBuilderPicksStore?.selectedBetSlip) {
		return null;
	}

	return (
		<div className="popup popup--qp popup--bbp">
			<div className="popup__card popup--qp__card popup--bbp__card">
				<BetBuilderPicksPopupHeader
					slipNumber={
						store.betBoosterEventPicks.betBuilderPicksStore
							.slipIndex
					}
					slip={
						store?.betBoosterEventPicks?.betBuilderPicksStore
							?.selectedBetSlip
					}
					isLive={
						store?.betBoosterEventPicks?.betBuilderPicksStore
							?.selectedBetSlip.isLive
					}
					cb={
						store?.betBoosterEventPicks?.betBuilderPicksStore
							?.deactivatePopup
					}
				/>
				<div
					className="popup__body popup--qp__body popup--bbp__body"
					ref={popupElement}
				>
					<BetBuilderPickEventPopupBody
						key={
							store?.betBoosterEventPicks?.betBuilderPicksStore
								?.selectedBetSlip.id
						}
						BBPick={
							store?.betBoosterEventPicks?.betBuilderPicksStore
								?.selectedBetSlip
						}
					/>
				</div>

				<BetBuilderPicksPopupFooter
					store={store.betBoosterEventPicks.betBuilderPicksStore}
					slip={
						store?.betBoosterEventPicks?.betBuilderPicksStore
							?.selectedBetSlip
					}
					slipNumber={
						store.betBoosterEventPicks.betBuilderPicksStore
							.slipIndex
					}
				/>
			</div>
		</div>
	);
});
